import { Stack } from "@mui/material";
import Link from "next/link";
import React from "react";
import { MdInfoOutline } from "react-icons/md";
import { SSText } from "src/components/base/components/SSText";
import { routes } from "src/shared/routes";
import { TRegistrationCardData } from "src/shared/types/globalStotre.types";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import { createJsxLink } from "src/utils/create-jsx-link";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Gators Student Ticket Offers",
    description: (
      <>
        Purchase single game & guest tickets below! Limited quantities of single
        game student and guest tickets for LIU and USF will be available
        starting at 10 am on Monday, August 4th.
        <br />
        <br />
        All other home games will go on sale no later than 2 weeks prior to that
        home game, based on availability.
      </>
    ),
    buttonLabel: "Buy Tickets",
    buttonVariant: "contained",
    authRedirectPage: routes.home,
  },
  {
    title: "Gators Student Registration",
    description:
      "Register your student football pass & link up to create groups to sit with your friends! Your unique link is located in your account. Please note seats are assigned the Friday before gameday. Additional guest tickets will be available for purchase. You must use the email address you purchased your pass with to login.",
    authRedirectPage: routes.my_group,
    buttonLabel: "Register Your Account",
    buttonVariant: "contained",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "Tickets will be delivered to your Florida Gators Account Manager the day before the game.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Yes, you can view your upcoming events to see all games that you are eligible for a ticket to.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will be notified tickets are available the day before the game via text message.",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations will be in the student section.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please contact the Gators box office for any assistance you may require.",
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer: (
      <>
        You can absolutely create a group to link with other pass holders!
        Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "gators_students" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        next to or close enough to hand a drink to one another for the game. You
        will need to ensure your group is created and all members have joined on
        the Monday before gameday.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets will be available for select games. You will receive an email confirming any guest ticket on-sale & availability.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my pass?",
    answer: "An active purchase is not refundable.",
  },
];

export const TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the{" "}
      {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")}{" "}
      and{" "}
      {createJsxLink(
        "Privacy Policy",
        "https://www.attend.tech/privacy-policy"
      )}
      .
    </>
  );
};

export const SWAF_INFO_TEXT = () => (
  <Stack
    p={1}
    my={2}
    gap={1}
    borderRadius={2}
    bgcolor="#CEE8F0"
    alignItems="center"
    flexDirection="row"
    flexWrap="nowrap"
  >
    <MdInfoOutline
      color="#014361"
      style={{
        flexShrink: 0,
        fontSize: 22,
        minWidth: 24,
        minHeight: 24,
      }}
    />
    <SSText
      variant="body2"
      color="#014361"
      sx={{
        wordBreak: "break-word",
        fontSize: { xs: "1rem", sm: "1rem" },
        lineHeight: 1.4,
        fontWeight: 400,
        display: "inline",
      }}
    >
      Create groups with eligible students — you&apos;ll only be seated together
      for games you&apos;ve bought tickets to.
    </SSText>
  </Stack>
);

export const FOOTER_LINKS = () => (
  <>
    <Link
      target="_blank"
      href="https://www.attend.tech/terms-of-use"
      style={{ color: "white " }}
    >
      Terms of Use
    </Link>{" "}
    <Link
      target="_blank"
      href="https://www.attend.tech/privacy-policy"
      style={{ color: "white " }}
    >
      Privacy Policy
    </Link>
  </>
);

export const CHECKOUT_TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the{" "}
      <Link target="_blank" href="https://www.attend.tech/terms-of-use">
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link target="_blank" href="https://www.attend.tech/privacy-policy">
        Privacy Policy
      </Link>
      .
    </>
  );
};
